import { Flex, StyledText, Types } from "@emonvia/web-components";
import ExclamationIcon from "@/assets/images/exclamation.svg";
import { Button } from "@/components/TrackedComponents/reevComponents";
import { Trans, useTranslation } from "react-i18next";
import { StyledReevModal } from "@/components/Modal/styles";
import { BoldText } from "@/components/BoldText";

type DisableReevEmsModalProps = {
  handleDisableEms: () => void;
  setShowDisableEmsModal: (enabled: boolean) => void;
};
export const DisableReevEmsModal = ({
  handleDisableEms,
  setShowDisableEmsModal
}: DisableReevEmsModalProps) => {
  const { t } = useTranslation();
  return (
    <StyledReevModal
      closable={false}
      header={
        <Flex flexDirection="column" alignItems="center" gap={20}>
          <img src={ExclamationIcon} alt={`${ExclamationIcon} + img`} width={72} height={72} />
          <StyledText
            text={t("DEACTIVE_REEV_EMS")}
            type={Types.ns_18_sb}
            style={{ fontWeight: 700 }}
          />
        </Flex>
      }
      size={"small"}
      actions={
        <>
          <Button
            onClick={() => {
              handleDisableEms();
              setShowDisableEmsModal(false);
            }}
            useNunitoFont
            label={t("YES_DEACTIVATE")}
          />
          <Button
            onClick={() => setShowDisableEmsModal(false)}
            useNunitoFont
            classNames="secondary-button"
            label={t("BACK")}
            look="secondary"
          />
        </>
      }
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
        <div>{t("ARE_YOU_SURE_YOU_DO_NOT_WANT_TO_USE_THE_REEV_EMS")}</div>
        <div>
          <Trans
            i18nKey="IT_ENSURES_THE_SAFE_OPERATION_OF_YOUR_ELECTRICAL_INFRASTRUCTURE_AND_IS_COMPLETELY_FREE"
            components={{ bold: <BoldText /> }}
          />
        </div>
      </div>
    </StyledReevModal>
  );
};
